import type { FormConfig } from '../types';
import coverSheet from '../pages/dcat/coverSheet';

const formConfig: FormConfig = {
  live: false,
  id: 'dcat',
  formName: 'DCAT Placeholder Form',
  title: 'DCAT Placeholder Form',
  subTitle: 'Summary page',
  showSections: true,
  approval: 'optional',
  sections: [
    {
      title: 'Main Section',
      slug: 'main-section',
      subsections: [
        {
          title: 'Cover Sheet',
          slug: 'cover-sheet',
          pages: coverSheet,
        },
      ],
    },
  ],
};

export default formConfig;
